import React from "react";
import { Container } from "@mui/material";
import { Page } from "~/layout";
import { UserCreateForm } from "./user-create-form";

export function UserCreatePage({
  navigation,
  breadcrumbs,
}: {
  navigation: React.ReactNode;
  breadcrumbs?: React.ReactNode;
}) {
  return (
    <Page title="New User" navigation={navigation}>
      <Container fixed>
        {breadcrumbs}
        <UserCreateForm />
      </Container>
    </Page>
  );
}
